// src/pages/ToursAndTravels.jsx
import React from "react";
import SectionTitle from "../homeComponents/common/SectionTitle";
import ToursSection from "../homeComponents/home/ToursSection";

const ToursAndTravels = () => (
  <section className="mx-auto max-w-6xl px-4 py-10 pb-24">
    <SectionTitle
      eyebrow="NJV"
      title="Tours & Travels"
      subtitle="Car rental, van rental, coach rental, airport transfers, outstation trips and local travel."
    />
    <div className="mt-8">
      <ToursSection />
    </div>
  </section>
);

export default ToursAndTravels;